import React, { Component } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import {
  getAllWarehouses,
  getWarehouses,
} from "../../../../services/inventory/warehouseService";
import withGlobalData from "../../common/withGlobalData";
class SearchWarehouse extends Component {
  state = {
    reload: this.props.globalData.reload,
    open: false,
    warehouses: [],
    warehouse: {},
  };

  componentDidMount() {
    this.getWarehousesData();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getWarehousesData();
      this.setState({ reload: globalData.reload });
    }
  }

  async getWarehousesData() {
    const { allWarehouses } = this.props;
    let response = {};
    if (allWarehouses) {
      response = await getAllWarehouses();
    } else {
      response = await getWarehouses();
    }

    const { data } = response.data;
    this.setState({ open: false, warehouses: data.warehouses });
  }

  render() {
    const { warehouses } = this.state;
    const { onSelectWarehouse } = this.props;
    return (
      <React.Fragment>
        <CustomDataTableSearch
          data={warehouses}
          onRefreshData={() => {
            this.getWarehousesData();
          }}
          onSelectedData={(rowData, originalEvent) => {
            onSelectWarehouse(rowData);
          }}
          columns={[
            {
              field: "select",
              body: (rowData) => (
                <React.Fragment>
                  <button
                    type="button"
                    className="btn btn-label-success btn-sm btn-pill btn-bold"
                    onClick={() => onSelectWarehouse(rowData)}
                  >
                    Select <i className="fas fa-angle-double-right"></i>
                  </button>
                </React.Fragment>
              ),
            },
            {
              header: "Warehouse ID",
              field: "ID",
              body: null,
              sortable: true,
            },
            {
              header: "Warehouse Name",
              field: "warehouseName",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis
                    text={rowData.warehouseName}
                    maxLine="1"
                  />
                </React.Fragment>
              ),
              sortable: true,
            },
            {
              header: "Phone Number",
              field: "addressPhone",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis text={rowData.addressPhone} maxLine="1" />
                </React.Fragment>
              ),
              sortable: true,
            },
            {
              header: "City",
              field: "city",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis text={rowData.city} maxLine="1" />
                </React.Fragment>
              ),
              sortable: true,
            },
          ]}
        />
      </React.Fragment>
    );
  }
}

export default withGlobalData(SearchWarehouse);
